import React from 'react';
import { EntityLink } from 'src/components/BeaconV2Components/MetricList/headColumnDefinitions';
import { PortfolioEditStore } from './PortfolioEditModal';
import Radio from 'src/components/BeaconV2Components/common/StyledRadio/StyledRadio';
import numeral from 'numeral';

export const PortfolioColumnDefinition = {
  headerName: 'PORTFOLIOS',
  valueFormatter: (_, row: { name: string; id: string }) => {
    const { selectedPortfolio, setSelectedPortfolio } = PortfolioEditStore();
    return (
      <div style={{ display: 'flex' }}>
        <Radio
          checked={selectedPortfolio === row.id}
          onClick={() => {
            if (selectedPortfolio === row.id) {
              setSelectedPortfolio('');
            } else {
              setSelectedPortfolio(row.id);
            }
          }}
          sx={{
            marginRight: '8px',
            input: {
              height: '12px',
              width: '12px'
            }
          }}
        />
        <EntityLink id={row.id} entityType="adPortfolio" className="editPortfolio__link">
          {row.name}
        </EntityLink>
      </div>
    );
  }
};

export const PortfolioIdDefinition = {
  headerName: 'PORTFOLIO ID',
  valueFormatter(_, row: { extendedAttributes: { portfolioId: string } }) {
    return row.extendedAttributes.portfolioId;
  }
};

export const PortfolioBudgetDefinition = {
  headerName: 'MONTHLY BUDGET',
  valueFormatter(_, row: { extendedAttributes: { liveBudgetSetting: { amount: number } } }) {
    return `$${numeral(row.extendedAttributes?.liveBudgetSetting?.amount ?? 1).format('1,000')}`;
  }
};
